export const CREATE_PLAYER = 'player/CREATE_PLAYER'
export const CREATE_PLAYER_FAILED = 'player/CREATE_PLAYER_FAILED'
export const CREATE_PLAYER_SUCCESS = 'player/CREATE_PLAYER_SUCCESS'
export const PLAYER_PUSHER_REQUEST = 'player/PLAYER_PUSHER_REQUEST'
export const PLAYER_CHECK_SUCCESS = 'player/PLAYER_CHECK_SUCCESS'
export const PLAYER_CHECK_FAILED = 'player/PLAYER_CHECK_FAILED'
export const PLAYER_CHECK = 'player/PLAYER_CHECK'
export const PLAYER_GUESS = 'player/PLAYER_GUESS'
export const PLAYER_GUESS_SUCCESS = 'player/PLAYER_GUESS_SUCCESS'
export const PLAYER_GUESS_FAILED = 'player/PLAYER_GUESS_FAILED'
export const RESET_GUESS_DATA = 'player/RESET_GUESS_DATA'
export const GET_HOST_PLAYLIST = 'player/GET_HOST_PLAYLIST'
export const GUEST_NAME = 'player/GUEST_NAME'
export const PLAYER_SCORE = 'player/PLAYER_SCORE'
export const PLAYER_TOTAL_SCORE = 'player/PLAYER_TOTAL_SCORE'
export const PLAYER_SONGS_PLAYED = 'player/PLAYER_SONGS_PLAYED'
export const UPDATE_PLAYERS_PICKS = 'player/UPDATE_PLAYERS_PICKS'
